import React, { useEffect, useState } from 'react';
// import config from './config'; // 导入配置文件
import init, { tsp } from './pkg/tsp_wasm'; // 导入 wasm 模块

const Amap = () => {
    const getConfig = () => {
        const storedConfig = localStorage.getItem('config');
        if (storedConfig) {
            const parsedConfig = JSON.parse(storedConfig);
            // console.log('API Keys Loaded:', parsedConfig);
            return parsedConfig;
        } else {
            console.error('未找到 API 密钥，请先配置。');
            return null;
        }
    };
    // let config = getConfig();
    const [config, setConfig] = useState(null); // 当前标记实例
    const [searchTerm, setSearchTerm] = useState(''); // 搜索文本
    const [suggestions, setSuggestions] = useState([]); // 搜索建议
    const [map, setMap] = useState(null); // 地图实例
    const [marker, setMarker] = useState(null); // 当前标记实例
    const [favorites, setFavorites] = useState([]); // 收藏列表
    const [isFavoritesVisible, setIsFavoritesVisible] = useState(false); // 控制收藏夹可见性
    const [isPathPanelVisible, setIsPathPanelVisible] = useState(false); // 控制 path-panel 可见性
    const [areMarkersVisible, setAreMarkersVisible] = useState(false); // 控制标记可见性
    const [markers, setMarkers] = useState([]); // 用于存储所有标记的数组
    const [lines, setLines] = useState([]); // 存储线段的数组
    const [isDrivingRoute, setIsDrivingRoute] = useState(false);

    // 初始化 Wasm 模块
    useEffect(() => {
        const loadWasm = async () => {
            await init(); // 初始化 Wasm 模块
            console.log('Wasm module loaded');
        };

        loadWasm();
    }, []);


    useEffect(() => {
        let config = getConfig();
        setConfig(config);
        // 从 localStorage 获取收藏夹数据
        const storedFavorites = localStorage.getItem('favorites');
        if (storedFavorites) {
            const parsedFavorites = JSON.parse(storedFavorites);
            setFavorites(parsedFavorites); // 初始化收藏夹
        }

        // 设置安全密钥
        window._AMapSecurityConfig = {
            securityJsCode: config.jsSecureKey, // 使用配置文件中的安全密钥
        };

        // 加载高德地图脚本
        const loadAmapScript = () => {
            const script = document.createElement('script');
            script.src = `https://webapi.amap.com/maps?v=2.0&key=${config.jsApiKey}`; // 使用配置文件中的 API Key
            script.async = true;
            script.onload = () => {
                const amap = new window.AMap.Map('map-container', {
                    zoom: 12, // 初始化缩放级别
                    center: [113.2361, 23.1091], // 初始中心点
                });
                amap.on('click', handleMapClick); // 添加地图点击事件监听器
                setMap(amap); // 保存地图实例
            };
            document.body.appendChild(script);
        };

        loadAmapScript();

        // 清理加载的脚本
        return () => {
            const script = document.querySelector(`script[src="https://webapi.amap.com/maps?v=2.0&key=${config.jsApiKey}"]`);
            if (script) {
                document.body.removeChild(script);
            }
        };
    }, []);

    const handleMapClick = () => {
        setSuggestions([]); // 点击地图时清空候选项
    };

    // 显示或隐藏所有标记
    const toggleMarkersVisibility = () => {
        // 清除当前单个标记（如果存在）
        if (marker) {
            marker.setMap(null);
            setMarker(null); // 清空当前标记状态
        }
        if (areMarkersVisible) {
            // 隐藏所有标记
            markers.forEach(marker => {
                marker.setMap(null); // 隐藏标记
            });
            setMarkers([]); // 清空标记数组
        } else {
            // 显示所有标记
            const newMarkers = favorites.map(favorite => {
                const { location: lnglat, name } = favorite;
                const [lng, lat] = lnglat.split(',').map(Number);

                const newMarker = new window.AMap.Marker({
                    position: new window.AMap.LngLat(lng, lat),
                    title: name,
                    label: {
                        content: name,
                        offset: new window.AMap.Pixel(0, -20),
                    },
                });

                newMarker.setMap(map); // 将标记添加到地图上
                return newMarker; // 返回新标记
            });
            setMarkers(newMarkers); // 更新标记数组
        }
        setAreMarkersVisible(!areMarkersVisible); // 切换状态
    };

    // 选择单个收藏项
    const selectFavorite = (favorite) => {
        if (map) {
            const { location: lnglat, name } = favorite; // 获取经纬度和名称
            const [lng, lat] = lnglat.split(',').map(Number);

            // 如果已有标记则移除
            if (marker) {
                marker.setMap(null);
            }

            // 创建新的标记，使用默认的标记
            const newMarker = new window.AMap.Marker({
                position: new window.AMap.LngLat(lng, lat),
                title: name,
                label: {
                    content: name,
                    offset: new window.AMap.Pixel(0, -20),
                },
            });

            newMarker.setMap(map); // 将标记添加到地图上
            setMarker(newMarker); // 保存标记实例

            // 直接设置地图中心和缩放级别，取消动画
            map.setCenter(new window.AMap.LngLat(lng, lat));
            map.setZoom(12); // 设置合适的缩放级别，直接跳到目标位置

            // 如果之前显示了所有标记，则清除它们
            if (areMarkersVisible) {
                markers.forEach(marker => {
                    marker.setMap(null); // 隐藏之前所有标记
                });
                setMarkers([]); // 清空标记数组
                setAreMarkersVisible(false); // 更新状态
            }
        }
    };


    // 计算两点之间的欧几里得距离
    const euclideanDistance = (point1, point2) => {
        // console.log(`计算距离 ${point1.name} -> ${point2.name}`);
        // console.log('点', point1, point2);
        // console.log('经纬度:', point1.lng, point1.lat, point2.lng, point2.lat);
        const { location: lnglat1 } = point1; // 获取经纬度和名称
        const { location: lnglat2 } = point2; // 获取经纬度和名称
        const [lng1, lat1] = lnglat1.split(',').map(Number);
        const [lng2, lat2] = lnglat2.split(',').map(Number);
        const dx = lng1 - lng2;
        const dy = lat1 - lat2;
        return Math.sqrt(dx * dx + dy * dy);
    };

    const haversineDistance = (point1, point2) => {
        const { location: lnglat1 } = point1; // 获取经纬度和名称
        const { location: lnglat2 } = point2; // 获取经纬度和名称
        const [lng1, lat1] = lnglat1.split(',').map(Number);
        const [lng2, lat2] = lnglat2.split(',').map(Number);

        // 将经纬度转换为弧度
        const toRadians = (degrees) => degrees * (Math.PI / 180);

        const R = 6371; // 地球半径，单位为公里
        const dLat = toRadians(lat2 - lat1); // 纬度差
        const dLng = toRadians(lng2 - lng1); // 经度差

        // Haversine 公式
        const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(toRadians(lat1)) * Math.cos(toRadians(lat2)) *
            Math.sin(dLng / 2) * Math.sin(dLng / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

        return R * c; // 返回距离，单位为公里
    };

    function calculateDrivingRoute(startLngLat, endLngLat, callback) {
        window.AMap.plugin("AMap.Driving", function () {
            var driving = new window.AMap.Driving({
                policy: 10, // 驾车路线规划策略，10是使用最短时间
            });

            // 执行驾车路线查询
            driving.search(startLngLat, endLngLat, function (status, result) {
                // status：complete 表示查询成功，no_data 为查询无结果，error 代表查询错误
                if (status === 'complete') {

                    const minDistanceRoute = result.routes.reduce((prev, curr) => {
                        return (curr.distance < prev.distance) ? curr : prev;
                    });
                    // console.log('导航路径规划成功,距离:', minDistanceRoute.distance);
                    // 调用回调函数并传递结果
                    callback(null, minDistanceRoute);
                } else {
                    console.error('导航路径规划失败:', result);
                    // 调用回调函数并传递错误信息
                    callback(result.info || '查询无结果');
                }
            });
        });
    }

    const getDistanceMatrix = async () => {
        if (!isDrivingRoute) {
            const distances = [];
            const numFavorites = favorites.length;

            for (let i = 0; i < numFavorites; i++) {
                const row = [];
                for (let j = 0; j < numFavorites; j++) {
                    if (i === j) {
                        row.push(0); // 自己到自己距离为 0
                    } else {
                        // const dist = euclideanDistance(favorites[i], favorites[j]) * 100000;
                        const dist = haversineDistance(favorites[i], favorites[j]) * 1000;
                        // console.log(`距离 ${favorites[i].name} -> ${favorites[j].name}: ${dist}`);
                        if (dist > 1500000000) { // 超过 int32 范围
                            console.warn(`距离超出 int32 范围: ${dist}`);
                            row.push(1500000000); // 设置为 int32 最大值
                        } else {
                            row.push(Math.floor(dist)); // 转为整数
                        }
                    }
                }
                distances.push(row);
            }
            return [distances, null];
        } else {
            console.log('计算驾车距离矩阵');
            const numFavorites = favorites.length;
            const distances = Array.from({ length: numFavorites }, () => Array(numFavorites).fill(0)); // 初始化二维数组
            const routes = Array.from({ length: numFavorites }, () => Array(numFavorites).fill(null));
            // 创建一个 Promise 数组
            const promises = [];

            for (let i = 0; i < numFavorites; i++) {
                for (let j = 0; j < numFavorites; j++) {
                    if (i === j) {
                        distances[i][j] = 0; // 自己到自己距离为 0
                    } else {
                        const point1 = favorites[i];
                        const point2 = favorites[j];
                        const { location: lnglat1 } = point1; // 获取经纬度和名称
                        const { location: lnglat2 } = point2; // 获取经纬度和名称
                        const startLngLat = lnglat1.split(',').map(Number);
                        const endLngLat = lnglat2.split(',').map(Number);

                        // 将计算距离的调用封装为 Promise
                        const promise = new Promise((resolve) => {
                            calculateDrivingRoute(startLngLat, endLngLat, (error, result) => {

                                if (error) {
                                    console.error(`计算距离失败: ${error}`);
                                    distances[i][j] = 1_500_000_000; // 设置为 1_500_000_000
                                    routes[i][j] = null;
                                } else {
                                    const dist = result.distance; // 从结果中获取距离
                                    if (dist > 1_500_000_000) { // 超过 1_500_000_000 范围
                                        console.warn(`距离超出范围: ${dist}`);
                                        distances[i][j] = 1_500_000_000; // 设置为 1_500_000_000
                                        routes[i][j] = result;
                                    } else {
                                        distances[i][j] = Math.floor(dist); // 转为整数
                                        routes[i][j] = result;
                                    }
                                }
                                resolve(); // 解析 Promise
                            });
                        });
                        promises.push(promise); // 将 Promise 加入数组
                        if (promises.length % 3 === 0) {
                            console.log(`已处理 ${promises.length} 个请求. 等待 1s ...`);
                            await new Promise(resolve => setTimeout(resolve, 1000)); // 阻塞 1 秒
                        }
                    }
                }
            }

            // 等待所有 Promise 完成
            await Promise.all(promises);
            console.log('所有驾车距离计算完成:', distances); // 在所有请求完成后输出 distances
            return [distances, routes]; // 返回结果
        }

    }

    function drawRoute(route) {
        var path = parseRouteToPath(route);

        var routeLine = new window.AMap.Polyline({
            path: path,
            isOutline: true,
            outlineColor: '#ffeeee',
            borderWeight: 2,
            strokeWeight: 6, // 线段宽度
            strokeOpacity: 0.85, // 线段透明度
            strokeColor: '#3CCC4E', // 线段颜色
            lineJoin: 'round',
            strokeStyle: 'solid', // 实线            
            showDir: true,
        });
        routeLine.setMap(map); // 将线段添加到地图上
        setLines([...lines, routeLine]); // 保存线段
        // newLines.push(polyline); // 保存线段
        // map.add(routeLine);

        // 调整视野达到最佳显示区域
        // map.setFitView(routeLine);
    }

    // 解析DrivingRoute对象，构造成AMap.Polyline的path参数需要的格式
    function parseRouteToPath(route) {
        // return route.steps.flatMap(step => step.path);
        let path = [];
        for (let i = 0, l = route.steps.length; i < l; i++) {
            let step = route.steps[i];
            for (let j = 0, n = step.path.length; j < n; j++) {
                path.push(step.path[j]);
            }
        }
        // console.log('路径:', path);
        return path;
    }

    // 调用 TSP 函数并显示结果
    const handleTspClick = async () => {
        // 计算距离矩阵

        const [distances, routes] = await getDistanceMatrix();
        const numFavorites = favorites.length;
        // console.log('点个数:', favorites.length);
        // console.log('距离矩阵:', distances);
        // console.log('路径矩阵:', routes);

        // 调用 wasm 中的 tsp 函数
        const flattenDistances = distances.flat();
        if (flattenDistances.some(distance => distance >= 1500000000)) {
            console.log("罢工了"); // 打印 "罢工了"
            const pathPanel = document.getElementById("path-panel");
            pathPanel.innerHTML = '罢工了'; // 在页面上显示 "罢工了"
            return; // 提前返回
        }

        // 开始计时
        console.time('TSPExecutionTime');
        const result = tsp(numFavorites, flattenDistances); // 直接调用 tsp 函数
        // 结束计时并打印耗时
        console.timeEnd('TSPExecutionTime');
        console.log('TSP 结果:', result);

        // 清空 path-panel 内容
        const pathPanel = document.getElementById("path-panel");
        pathPanel.innerHTML = '';

        // 显示 TSP 结果
        const path = result.slice(0, -1); // 去掉最后一个元素（总距离）
        const totalDistance = result[result.length - 1];
        // console.log( path.map(p => (console.log(p,favorites[p].name), favorites[p].name)) );


        const np = Array.from(path);
        let pathArray = [...np, 0]; // 将起点 0 添加到路径末尾

        // 获取第0个点到第1个点的距离
        const distance01 = distances[pathArray[0]][pathArray[1]];
        // 获取最后一个点到第0个点的距离
        const distanceN0 = distances[pathArray[pathArray.length - 2]][pathArray[0]];

        // 检查条件，反转路径
        if ((!routes) && (distance01 > distanceN0)) {
            pathArray.reverse(); // 反转路径，但不包括最后的总距离
        }

        // 添加路径
        const pathList = document.createElement('ul');
        pathList.style.fontWeight = 'bold'; // 设置字体为加粗
        pathList.style.listStyleType = 'none'; // 去掉列表前的默认样式
        pathList.style.padding = '0'; // 去掉默认内边距
        const dispDistance = Number.isInteger(totalDistance / 1000) ? totalDistance / 1000 : (totalDistance / 1000).toFixed(3);
        if (routes) {
            // 计算总时间
            let totalTime = 0; // 初始化总时间
            for (let i = 0; i < pathArray.length - 1; i++) {
                totalTime += routes[pathArray[i]][pathArray[i + 1]].time; // 累加每段路径的时间
            }

            // 格式化总时间
            const totalHours = Math.floor(totalTime / 3600); // 计算总小时
            const totalMinutes = Math.ceil((totalTime % 3600) / 60); // 计算总分钟，向上取整
            const totalTimeString = totalHours > 0 ? `${totalHours}h${totalMinutes}m` : `${totalMinutes}m`; // 格式化总时间

            pathList.innerHTML = `<li>总距离: ${dispDistance} 公里，总时间: ${totalTimeString}，共 ${pathArray.length - 1} 个地点</li>`;
        } else {
            pathList.innerHTML = `<li>总距离: ${dispDistance} 公里，共 ${pathArray.length - 1} 个地点</li>`;
        }


        if (routes) {
            const pathWithTimes = pathArray.map((point, index) => {
                const favorite = favorites[point];
                const time = index < pathArray.length - 1 ? routes[point][pathArray[index + 1]].time : 0; // 获取对应时间，最后一个点的时间设为0
                const hours = Math.floor(time / 3600); // 计算小时
                const minutes = Math.ceil((time % 3600) / 60); // 计算分钟，向上取整

                // const timeString = `${hours}h${minutes}m`; // 格式化为 1h53m
                let timeString = '';
                if (index < pathArray.length - 1) { // 确保不是最后一个点
                    if (hours > 0) {
                        timeString = `(${hours}h${minutes}min)`; // 显示小时和分钟
                    } else {
                        timeString = `(${minutes}min)`; // 只显示分钟
                    }
                }
                return favorite ? `${favorite.name}${timeString}` : '未知地点'; // 返回地点名称和耗时
            });
            pathList.innerHTML += `<li>路径: ${pathWithTimes.join(' -> ')}</li>`;
        } else {
            pathList.innerHTML += `<li>路径: ${pathArray.map(p => (favorites[p] ? favorites[p].name : '未知地点')).join(' -> ')}</li>`;
        }

        pathPanel.appendChild(pathList);

        // 打印距离矩阵到 path-panel
        const matrixTable = document.createElement('table');
        matrixTable.style.borderCollapse = 'collapse';
        matrixTable.style.margin = '0 auto'; // 使表格横向居中

        // 创建表头
        const headerRow = document.createElement('tr');
        headerRow.appendChild(document.createElement('th')); // 空单元格，用于行名
        favorites.forEach(fav => {
            const th = document.createElement('th');
            th.innerText = fav.name; // 使用原名
            th.style.border = 'none'; // 去掉列名的边框
            th.style.padding = '1px';
            headerRow.appendChild(th);
        });
        matrixTable.appendChild(headerRow);

        // 创建数据行
        distances.forEach((row, i) => {
            const tr = document.createElement('tr');
            const th = document.createElement('th');
            th.innerText = favorites[i].name; // 行名
            th.style.border = 'none'; // 去掉行名的边框
            th.style.padding = '1px';
            tr.appendChild(th);

            row.forEach(cell => {
                const td = document.createElement('td');
                td.innerText = Number.isInteger(cell / 1000) ? (cell / 1000).toString() : (cell / 1000).toFixed(1); // 将距离转换为公里并判断是否为整数
                td.style.border = '1px solid black'; // 保留矩阵内单元格的边框
                td.style.padding = '1px';
                tr.appendChild(td);
            });

            matrixTable.appendChild(tr);
        });

        // 将矩阵表格添加到 path-panel
        pathPanel.appendChild(matrixTable);

        if (!areMarkersVisible) {
            toggleMarkersVisibility(); // 自动显示所有标记
        }

        // 清除之前的线段
        lines.forEach(line => line.setMap(null)); // 隐藏之前的线段
        setLines([]); // 清空线段数组

        // 画线段和标注序号

        const newLines = []; // 存储新线段

        if (routes) {
            //补全一下
            // 遍历 pathArray
            // console.log('routes:', routes);
            let segmentNumber = 1; // 用于标记线段序号
            pathArray.forEach((point, index) => {
                if (index < pathArray.length - 1) {
                    // 获取当前和下一个点的路线
                    const route = routes[point][pathArray[index + 1]]; // 从 routes 中获取路线
                    const path = parseRouteToPath(route); // 解析路线为路径

                    // 创建线段
                    const routeLine = new window.AMap.Polyline({
                        path: path,
                        isOutline: true,
                        outlineColor: '#ffeeee',
                        borderWeight: 2,
                        strokeWeight: 6, // 线段宽度
                        strokeOpacity: 0.85, // 线段透明度
                        strokeColor: '#3CCC4E', // 线段颜色
                        lineJoin: 'round',
                        strokeStyle: 'solid', // 实线
                        showDir: true,
                    });
                    routeLine.setMap(map); // 将线段添加到地图上
                    newLines.push(routeLine); // 保存线段

                    // 在线段中间添加文本
                    if (path.length > 0) {
                        const markPoint = path[0]; // 获取终点的坐标

                        // 计算中间点
                        // const midPointIndex = Math.floor(path.length / 2); // 取中间的点索引
                        // const midPoint = path[midPointIndex]; // 获取中间点的坐标
                        // console.log('中间点:', midPoint);
                        const text = new window.AMap.Text({
                            text: segmentNumber.toString(), // 标注序号
                            position: new window.AMap.LngLat(markPoint.lng, markPoint.lat), // 中间点的经纬度
                            style: {
                                'color': 'red', // 文本颜色
                                fontSize: '16px', // 字体大小
                                fontWeight: 'bold', // 字体加粗
                            },
                            offset: new window.AMap.Pixel(0, -20), // 调整位置
                        });
                        text.setMap(map); // 将文本添加到地图上
                        newLines.push(text); // 保存文本

                        segmentNumber++; // 增加线段序号
                    }
                }
            });
        } else {
            pathArray.forEach((point, index) => {
                if (index < pathArray.length - 1) {
                    const startPoint = favorites[point].location.split(',').map(Number);
                    const endPoint = favorites[pathArray[index + 1]].location.split(',').map(Number);

                    // 创建线段
                    const polyline = new window.AMap.Polyline({
                        path: [
                            new window.AMap.LngLat(startPoint[0], startPoint[1]),
                            new window.AMap.LngLat(endPoint[0], endPoint[1])
                        ],
                        strokeColor: '#3CCC4E', // 线段颜色
                        strokeOpacity: 0.85, // 线段透明度
                        strokeWeight: 6, // 线段宽度
                        lineJoin: 'round', // 线段连接样式
                        strokeStyle: 'solid', // 实线
                        showDir: true,
                    });
                    polyline.setMap(map); // 将线段添加到地图上
                    newLines.push(polyline); // 保存线段

                    // 在线段中间添加文本
                    const midPoint = [
                        (startPoint[0] + endPoint[0]) / 2,
                        (startPoint[1] + endPoint[1]) / 2
                    ];
                    const text = new window.AMap.Text({
                        text: (index + 1).toString(), // 标注序号
                        position: new window.AMap.LngLat(midPoint[0], midPoint[1]),
                        style: {
                            'color': 'red', // 文本颜色
                            fontSize: '16px', // 字体大小
                            fontWeight: 'bold', // 字体加粗
                        },
                        offset: new window.AMap.Pixel(0, -20), // 调整位置
                    });
                    text.setMap(map); // 将文本添加到地图上
                    newLines.push(text); // 保存文本
                }
            });
        }

        setLines(newLines); // 更新线段状态

    };

    const clearLines = () => {
        lines.forEach(line => line.setMap(null)); // 隐藏所有线段和标注
        setLines([]); // 清空线段状态
    };


    // 执行搜索
    const performSearch = () => {
        if (searchTerm) {
            // console.log('搜索:', searchTerm);
            const apiKey = config.webApiKey; // 使用配置文件中的 Web API Key
            const searchUrl = `https://restapi.amap.com/v5/place/text?key=${apiKey}&keywords=${encodeURIComponent(searchTerm)}&city=广州&offset=5&page=1&extensions=all`;

            fetch(searchUrl)
                .then(response => response.json())
                .then(data => {
                    // console.log('搜索结果:', data);
                    if (data.status === '1') {
                        setSuggestions(data.pois); // 更新建议结果
                    } else {
                        setSuggestions([]); // 清空建议结果
                    }
                })
                .catch(error => {
                    console.error('搜索地点失败:', error);
                });
        } else {
            setSuggestions([]); // 清空建议结果
        }
    };

    // 处理输入框变化
    const handleInputChange = (e) => {
        setSearchTerm(e.target.value); // 更新搜索文本
    };

    // 处理按键事件
    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            performSearch(); // 按下回车键时执行搜索
        }
    };

    // 选择地点
    const selectLocation = (location) => {
        if (map) {
            const { location: lnglat, name } = location; // 获取经纬度和名称
            const [lng, lat] = lnglat.split(',').map(Number);

            // 如果已有标记则移除
            if (marker) {
                marker.setMap(null);
            }

            // 创建新的标记，使用默认的标记
            const newMarker = new window.AMap.Marker({
                position: new window.AMap.LngLat(lng, lat),
                title: name,
                label: { // 设置标签
                    content: name, // 显示的文本
                    offset: new window.AMap.Pixel(0, -20), // 调整标签位置
                },
            });

            newMarker.setMap(map); // 将标记添加到地图上
            setMarker(newMarker); // 保存标记实例

            // 直接设置地图中心和缩放级别，取消动画
            map.setCenter(new window.AMap.LngLat(lng, lat));
            map.setZoom(12); // 设置合适的缩放级别，直接跳到目标位置
            setSuggestions([]); // 清空建议结果
            setSearchTerm(''); // 清空搜索框
        }
    };

    // 收藏地点
    const toggleFavorite = (location) => {
        const isFavorite = favorites.some(fav => fav.id === location.id);
        let updatedFavorites;

        if (isFavorite) {
            // 取消收藏
            updatedFavorites = favorites.filter(fav => fav.id !== location.id);
        } else {
            // 收藏
            updatedFavorites = [...favorites, location];
        }

        setFavorites(updatedFavorites); // 更新状态
        localStorage.setItem('favorites', JSON.stringify(updatedFavorites)); // 更新 localStorage
    };

    // 点击收藏项
    const dec_selectFavorite = (favorite) => {
        if (map) {
            const { location: lnglat, name } = favorite; // 获取经纬度和名称
            const [lng, lat] = lnglat.split(',').map(Number);

            // 如果已有标记则移除
            if (marker) {
                marker.setMap(null);
            }

            // 创建新的标记，使用默认的标记
            const newMarker = new window.AMap.Marker({
                position: new window.AMap.LngLat(lng, lat),
                title: name,
                label: { // 设置标签
                    content: name, // 显示的文本
                    offset: new window.AMap.Pixel(0, -20), // 调整标签位置
                },
            });

            newMarker.setMap(map); // 将标记添加到地图上
            setMarker(newMarker); // 保存标记实例

            // 直接设置地图中心和缩放级别，取消动画
            map.setCenter(new window.AMap.LngLat(lng, lat));
            map.setZoom(12); // 设置合适的缩放级别，直接跳到目标位置
        }
    };

    // 测试按钮的点击处理
    const handleTestClick = () => {
        if (map) {
            window.AMap.plugin("AMap.Driving", function () {
                var driving = new window.AMap.Driving({
                    policy: 10, //驾车路线规划策略，0是速度优先的策略
                    // map: map, // 将路线规划方案绘制到对应的 AMap.Map 对象上
                    // panel: "path-panel", // 指定将结构化的路线详情数据显示的对应的 DOM 上
                });

                // var points = [
                //     { keyword: "北京市地震局（公交站）", city: "北京" },
                //     { keyword: "亦庄文化园（地铁站）", city: "北京" },
                // ];

                // // 搜索完成后，将自动绘制路线到地图上
                // driving.search(points);

                var startLngLat = [116.379028, 39.865042]; //起始点坐标
                var endLngLat = [116.427281, 39.903719]; //终点坐标
                driving.search(startLngLat, endLngLat, function (status, result) {
                    //status：complete 表示查询成功，no_data 为查询无结果，error 代表查询错误
                    //查询成功时，result 即为对应的驾车导航信息
                    console.log(status, result);
                    if (status === 'complete') {
                        //绘制驾车路线
                        console.log('导航路径规划成功');
                        const minDistanceRoute = result.routes.reduce((prev, curr) => {
                            return (curr.distance < prev.distance) ? curr : prev;
                        });
                        console.log('最短路径:', minDistanceRoute);
                        drawRoute(minDistanceRoute);
                    }
                });

            });
        }
    };

    // 切换路径面板的可见性
    const togglePathPanel = () => {
        setIsPathPanelVisible(!isPathPanelVisible); // 切换状态
    };

    return (
        <div style={{ position: 'relative', height: '100vh', width: '100vw' }}>
            {true &&
                <div style={{ position: 'absolute', top: '10px', left: '10px', display: 'flex', alignItems: 'center' }}>
                    {/* 收藏夹可见性控制按钮 */}
                    <button
                        onClick={() => setIsFavoritesVisible(!isFavoritesVisible)}
                        // onTouchStart={() => setIsFavoritesVisible(!isFavoritesVisible)}
                        // onMouseDown={() => setIsFavoritesVisible(!isFavoritesVisible)}
                        style={{
                            padding: '10px',
                            marginRight: '5px',
                            backgroundColor: '#007bff',
                            color: 'white',
                            border: 'none',
                            cursor: 'pointer',
                            zIndex: 1,
                        }}
                    >
                        {isFavoritesVisible ? '隐藏收藏夹' : '显示收藏夹'}
                    </button>

                    <input
                        type="text"
                        value={searchTerm}
                        onChange={handleInputChange}
                        onKeyPress={handleKeyPress}
                        placeholder="输入地点搜索..."
                        style={{
                            padding: '10px',
                            width: '300px',
                            zIndex: 1,
                        }}
                    />
                    <button
                        onClick={performSearch}
                        // onTouchStart={performSearch}
                        // onMouseDown={performSearch}
                        style={{
                            padding: '10px',
                            marginLeft: '5px',
                            backgroundColor: '#007bff',
                            color: 'white',
                            border: 'none',
                            cursor: 'pointer',
                            zIndex: 1,
                        }}
                    >
                        搜索
                    </button>

                    {/* 新增的测试按钮 */}
                    <button
                        onClick={handleTestClick}
                        // onTouchStart={handleTestClick}
                        // onMouseDown={handleTestClick}
                        style={{
                            padding: '10px',
                            marginLeft: '5px',
                            backgroundColor: '#28a745', // 绿色
                            color: 'white',
                            border: 'none',
                            cursor: 'pointer',
                            zIndex: 1,
                        }}
                    >
                        测试
                    </button>

                    {/* 新增的 TSP 按钮 */}
                    <button
                        onClick={handleTspClick}
                        // onTouchStart={handleTspClick}
                        // onMouseDown={handleTspClick}
                        style={{
                            padding: '10px',
                            marginLeft: '5px',
                            backgroundColor: '#17a2b8', // 青色
                            color: 'white',
                            border: 'none',
                            cursor: 'pointer',
                            zIndex: 1,
                        }}
                    >
                        跑TSP
                    </button>
                    {/* 新增的状态切换按钮 */}
                    <button
                        onClick={() => setIsDrivingRoute(!isDrivingRoute)} // 点击时切换状态
                        // onTouchStart={() => setIsDrivingRoute(!isDrivingRoute)} // 触摸时切换状态
                        // onMouseDown={() => setIsDrivingRoute(!isDrivingRoute)} // 鼠标按下时切换状态
                        style={{
                            padding: '10px',
                            marginLeft: '5px',
                            backgroundColor: '#A217B8',
                            color: 'white',
                            border: 'none',
                            cursor: 'pointer',
                            zIndex: 1,
                        }}
                    >
                        {isDrivingRoute ? '驾车' : '直线'} {/* 根据状态显示文本 */}
                    </button>

                    {/* 新增的清除线段按钮 */}
                    <button
                        onClick={clearLines}
                        // onTouchStart={clearLines}
                        // onMouseDown={clearLines}
                        style={{
                            padding: '10px',
                            marginLeft: '5px',
                            backgroundColor: '#dc3545', // 红色
                            color: 'white',
                            border: 'none',
                            cursor: 'pointer',
                            zIndex: 1,
                        }}
                    >
                        清除线段
                    </button>

                    {/* 新增的 + / - 按钮，用于展开/关闭 path-panel */}
                    <button
                        onClick={togglePathPanel}
                        // onTouchStart={togglePathPanel}
                        // onMouseDown={togglePathPanel}
                        style={{
                            padding: '10px',
                            marginLeft: '5px',
                            backgroundColor: '#ffc107', // 黄色
                            color: 'white',
                            border: 'none',
                            cursor: 'pointer',
                            zIndex: 1,
                        }}
                    >
                        {isPathPanelVisible ? '➖' : '➕'}
                    </button>
                </div>
            }

            {/* 始终存在的路径面板 */}
            <div id="path-panel" style={{
                position: 'absolute',
                top: '50px', // 设置为搜索框底部的位置
                left: '0',
                width: '100%', // 宽度为视窗宽度
                maxWidth: '100vw', // 最大宽度为视口宽度
                height: '40vh', // 高度占视窗的 4/10
                backgroundColor: 'rgba(255, 255, 255, 0.5)', // 背景透明
                visibility: isPathPanelVisible ? 'visible' : 'hidden', // 使用 visibility 控制可见性
                zIndex: 1,
                overflow: 'auto', // 滚动条
                display: 'flex', // 使用 flexbox 布局
                flexDirection: 'column', // 垂直方向布局
                alignItems: 'center', // 水平居中
                justifyContent: 'flex-start', // 垂直居中
            }}>
                <h4>路径信息</h4>
                {/* 在这里可以显示路径相关信息 */}
            </div>

            {/* 收藏栏 */}
            {isFavoritesVisible && (
                <div style={{
                    position: 'absolute',
                    top: '50px',
                    left: '10px',
                    backgroundColor: 'white',
                    border: '1px solid #ccc',
                    padding: '10px',
                    zIndex: 1,
                    maxHeight: '300px',
                    overflowY: 'auto',
                    width: '300px',
                    marginTop: '5px',
                }}>
                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between', // 使内容两端对齐
                        alignItems: 'center', // 垂直居中对齐
                        marginBottom: '10px', // 下边距
                    }}>
                        <h4 style={{
                            flex: 1, // 使 h4 占据剩余空间
                            textAlign: 'center', // 使文本居中
                            margin: 0,
                        }}>我的收藏</h4>
                        {/* 在这里插入收藏长度信息 */}
                        <span style={{
                            flex: 1,
                            margin: '0 10px', // 添加左右间距
                            fontSize: '16px', // 字体大小
                            color: 'black', // 字体颜色
                        }}>
                            共{favorites.length}个地点
                        </span>
                        <button
                            onClick={toggleMarkersVisibility}
                            style={{
                                padding: '10px',
                                backgroundColor: areMarkersVisible ? 'gray' : '#007bff',
                                color: 'white',
                                border: 'none',
                                cursor: 'pointer',
                                zIndex: 1,
                            }}
                        >
                            {areMarkersVisible ? '隐藏标记' : '显示标记'}
                        </button>
                    </div>

                    <ul style={{ listStyleType: 'none', padding: '0' }}>
                        {favorites.length > 0 ? (
                            favorites.map((favorite, index) => (
                                <li key={index} onClick={() => selectFavorite(favorite)} style={{
                                    padding: '10px',
                                    cursor: 'pointer',
                                    borderBottom: '1px solid #eee',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                }}>
                                    <span style={{ flex: 1 }}>{favorite.name}</span>
                                    <button
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            toggleFavorite(favorite);
                                        }}
                                        style={{
                                            backgroundColor: 'red',
                                            color: 'white',
                                            border: 'none',
                                            cursor: 'pointer',
                                            padding: '5px',
                                            borderRadius: '5px',
                                        }}
                                    >
                                        取消收藏
                                    </button>
                                </li>
                            ))
                        ) : (
                            <li style={{ padding: '10px' }}>没有收藏项</li>
                        )}
                    </ul>
                </div>
            )}

            {/* 候选栏，放置在搜索框下方，留一点间隔 */}
            {suggestions.length > 0 && (
                <ul style={{
                    position: 'absolute',
                    top: '50px', // 确保候选栏在收藏栏下方并留出间隔
                    left: '102px',
                    backgroundColor: 'white',
                    margin: '0',
                    listStyleType: 'none',
                    padding: '0',
                    border: '1px solid #ccc',
                    maxHeight: '200px',
                    overflowY: 'auto',
                    zIndex: 1,
                    width: '300px', // 设置宽度与输入框一致
                }}>
                    {suggestions.map((suggestion, index) => (
                        <li
                            key={index}
                            onClick={() => selectLocation(suggestion)}
                            style={{
                                padding: '10px',
                                cursor: 'pointer',
                                borderBottom: '1px solid #eee',
                                display: 'flex',
                                justifyContent: 'space-between',
                            }}
                        >
                            {suggestion.name}
                            <button
                                onClick={(e) => {
                                    e.stopPropagation(); // 阻止点击事件冒泡
                                    toggleFavorite(suggestion); // 收藏或取消收藏
                                }}
                                style={{
                                    backgroundColor: favorites.some(fav => fav.id === suggestion.id) ? 'red' : 'gray',
                                    color: 'white',
                                    border: 'none',
                                    cursor: 'pointer',
                                    padding: '5px',
                                    borderRadius: '5px',
                                }}
                            >
                                {favorites.some(fav => fav.id === suggestion.id) ? '取消收藏' : '收藏'}
                            </button>
                        </li>
                    ))}
                </ul>
            )}
            <div id="map-container" style={{ width: '100%', height: '100%' }}></div>
        </div>
    );
};

export default Amap;
